import React from 'react';
import { Card } from "react-bootstrap";
import face_image_1 from "../../assets/img/faceVivienSurman.jpg";
import face_image_2 from "../../assets/img/faceBarbaraArki.jpg";
import ShowMoreText from "react-show-more-text";
import proj_image from "../../assets/img/projSurmanV_ArkiB_quality.png";

const V_Surman_and_B_Arki_quality = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}
        <Card.Img variant="top" src={proj_image} />
        <br />
        <Card.Body>
          <Card.Text class="d-flex justify-content-between card-text">
            {" "}

            <div style={{width: '183px'}}> {/* This is an ugly solution, but it works for now */}
            <img
              className="img2"
              src={face_image_1}
              
            />{" "}
            <p className="text7">Vivien Surman{" "}</p>
            <br />
            <p className="text8">
              Associate Professor{" "}
            </p>
            </div>
            <div style={{width: '183px'}}>
            <img
              className="img2"
              src={face_image_2}
              
            />{" "}
            <p className="text7">Barbara Árki{" "}</p>
            <br />
            <p className="text8">
              PhD Student{" "}
            </p>
            </div>
            
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            <p className="text8">Department of Management and Business Economics, BME </p>
            </div>
            <div>
            <p className="text8">Doctoral School of Business and Management, BME </p>
            </div>
            <div>
            Artificial intelligence is increasingly integrated into higher education, raising questions related to quality, 
            acceptance, and responsible use. While AI-based tools offer significant potential for improving teaching, 
            learning, and institutional processes, their successful adoption depends on stakeholder expectations as well as 
            ethical, regulatory, and organizational factors. The aim of this research is to investigate the quality 
            dimensions of AI applications in the higher education sector. The study focuses on identifying best practices, 
            success factors, challenges, and stakeholder attitudes based on social media discourse (Facebook, Instagram, 
            TikTok, Reddit) and the state-of-the-art literature in selected countries. Special attention is given to 
            stakeholder expectations, as well as potential conflicts and synergies between different stakeholder groups. 
            The research emphasizes quantitative approaches, such as graph-based representations of stakeholder 
            interactions-attitudes, network metrics, and comparative statistical analysis across platforms and countries, etc.

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default V_Surman_and_B_Arki_quality;